import { RegisteredEmployeeDetailView } from '@iota/inh-core-v1-management-client';
import { CaseStatusType, EmployeeCaseAttributeDTO, EmployeeCaseDTO } from '@iota/iota-management-portal-v4-client';
import { createAction, props } from '@ngrx/store';
import { EmployeeRequestEntity } from '../entity-models';

export enum EmployeeCaseActionTypes {
    LoadEmployeeCaseById = '[EmployeeCase] Load Employee Cases By Id',

    LoadEmployeeCasesSuccess = '[EmployeeCase] Load Employee Cases Success',
    LoadEmployeeCasesFailure = '[EmployeeCase] Load Employee Cases Failure',

    AddNoteToCase = '[EmployeeCase] Add Note To Case',
    AddNoteToCaseSuccess = '[EmployeeCase] Add Note To Case Success',
    AddNoteToCaseFailure = '[EmployeeCase] Add Note To Case Failure',

    RemoveNoteFromCase = '[EmployeeCase] Remove Note From Case',
    RemoveNoteFromCaseSuccess = '[EmployeeCase] Remove Note From Case Success',
    RemoveNoteFromCaseFailure = '[EmployeeCase] Remove Note From Case Failure',

    CreateCaseAndOpen = '[EmployeeCase] Create Case And Open',
    CreateCaseSuccess = '[EmployeeCase] Create Case Success',

    UpdateCase = '[EmployeeCase] Update Case',
    UpdateCaseSuccess = '[EmployeeCase] Update Case Success',
    UpdateCaseFailure = '[EmployeeCase] Update Case Failure',

    UpdateCaseStatus = '[EmployeeCase] Update Case Status',
    UpdateCaseStatusSuccess = '[EmployeeCase] Update Case Status Success',
    UpdateCaseStatusFailure = '[EmployeeCase] Update Case Status Failure',

    CaseSubmissionsRejected = '[EmployeeCase] Case Submissions Rejected',
    RejectRequestsByCase = '[EmployeeCase] Reject Requests By Case',

    UpsertCaseAttribute = '[EmployeeCase] Upsert Case Attribute',
    UpsertCaseAttributeSuccess = '[EmployeeCase] Upsert Case Attribute Success',
    UpsertCaseAttributeFailure = '[EmployeeCase] Upsert Case Attribute Failure',

    UpsertEmployeeCaseAttachment = '[EmployeeCase] Upsert Case Attachment',
    UpsertEmployeeCaseAttachmentSuccess = '[EmployeeCase] Upsert Case Attachment Success',
    UpsertEmployeeCaseAttachmentFailure = '[EmployeeCase] Upsert Case Attachment Failure',

    RemoveEmployeeCaseAttachment = '[EmployeeCase] Remove Case Attachment',
    RemoveEmployeeCaseAttachmentSuccess = '[EmployeeCase] Remove Case Attachment Success',
    RemoveEmployeeCaseAttachmentFailure = '[EmployeeCase] Remove Case Attachment Failure',

    GenerateInhCertificate = '[EmployeeCase] Generate Inh Certificate',
    GenerateInhCertificateSuccess = '[EmployeeCase] Generate Inh Certificate Success',
    GenerateInhCertificateFailure = '[EmployeeCase] Generate Inh Certificate Failure'
}

export const LoadEmployeeCaseById = createAction(EmployeeCaseActionTypes.LoadEmployeeCaseById, props<{ caseId: string }>());

export const LoadEmployeeCasesSuccess = createAction(
    EmployeeCaseActionTypes.LoadEmployeeCasesSuccess,
    props<{ cases: EmployeeCaseDTO[] }>()
);
export const LoadEmployeeCasesFailure = createAction(EmployeeCaseActionTypes.LoadEmployeeCasesFailure, props<{ error: any }>());

export const AddNoteToCase = createAction(EmployeeCaseActionTypes.AddNoteToCase, props<{ caseId: string; note: string }>());
export const AddNoteToCaseSuccess = createAction(EmployeeCaseActionTypes.AddNoteToCaseSuccess, props<{ caseId: string }>());
export const AddNoteToCaseFailure = createAction(EmployeeCaseActionTypes.AddNoteToCaseFailure, props<{ error: any }>());

export const RemoveNoteFromCase = createAction(EmployeeCaseActionTypes.RemoveNoteFromCase, props<{ caseId: string; noteId: string }>());
export const RemoveNoteFromCaseSuccess = createAction(EmployeeCaseActionTypes.RemoveNoteFromCaseSuccess, props<{ caseId: string }>());
export const RemoveNoteFromCaseFailure = createAction(EmployeeCaseActionTypes.RemoveNoteFromCaseFailure, props<{ error: any }>());

export const CreateCaseAndOpen = createAction(
    EmployeeCaseActionTypes.CreateCaseAndOpen,
    props<{
        employee: RegisteredEmployeeDetailView;
        request: EmployeeRequestEntity;
        subscriptionIds?: string[];
        subSubscriptionIds?: string[];
        amount: number;
        dateOfClaimStart: string;
        dateOfClaimEnd: string;
        diagnosis: string;
        exportNote: string;
        gkvReimbursement: number;
    }>()
);
export const CreateCaseSuccess = createAction(EmployeeCaseActionTypes.CreateCaseSuccess, props<{ employeeId: string; caseId: string }>());

export const UpdateCase = createAction(EmployeeCaseActionTypes.UpdateCase, props<{ employeeCase: EmployeeCaseDTO }>());
export const UpdateCaseSuccess = createAction(EmployeeCaseActionTypes.UpdateCaseSuccess, props<{ caseId: string }>());
export const UpdateCaseFailure = createAction(EmployeeCaseActionTypes.UpdateCaseFailure, props<{ error: any }>());

export const UpdateCaseStatus = createAction(
    EmployeeCaseActionTypes.UpdateCaseStatus,
    props<{ caseId: string; newStatus: CaseStatusType; reason?: string }>()
);
export const UpdateCaseStatusSuccess = createAction(EmployeeCaseActionTypes.UpdateCaseStatusSuccess, props<{ caseId: string }>());
export const UpdateCaseStatusFailure = createAction(EmployeeCaseActionTypes.UpdateCaseStatusFailure, props<{ error: any }>());

export const CaseSubmissionsRejected = createAction(
    EmployeeCaseActionTypes.CaseSubmissionsRejected,
    props<{ employeeId: string; caseId: string }>()
);

export const UpsertCaseAttribute = createAction(
    EmployeeCaseActionTypes.UpsertCaseAttribute,
    props<{ caseId: string; attribute: EmployeeCaseAttributeDTO }>()
);
export const UpsertCaseAttributeSuccess = createAction(EmployeeCaseActionTypes.UpsertCaseAttributeSuccess, props<{ caseId: string }>());
export const UpsertCaseAttributeFailure = createAction(EmployeeCaseActionTypes.UpsertCaseAttributeFailure, props<{ error: any }>());

export const GenerateInhCertificate = createAction(EmployeeCaseActionTypes.GenerateInhCertificate, props<{ caseId: string }>());
export const GenerateInhCertificateSuccess = createAction(EmployeeCaseActionTypes.GenerateInhCertificateSuccess);
export const GenerateInhCertificateFailure = createAction(EmployeeCaseActionTypes.GenerateInhCertificateFailure, props<{ error: any }>());

export const UpsertEmployeeCaseAttachment = createAction(
    EmployeeCaseActionTypes.UpsertEmployeeCaseAttachment,
    props<{ file: File; employeeId: string; caseId: string }>()
);
export const UpsertEmployeeCaseAttachmentSuccess = createAction(
    EmployeeCaseActionTypes.UpsertEmployeeCaseAttachmentSuccess,
    props<{ caseId: string }>()
);
export const UpsertEmployeeCaseAttachmentFailure = createAction(
    EmployeeCaseActionTypes.UpsertEmployeeCaseAttachmentFailure,
    props<{ error: any }>()
);

export const RemoveEmployeeCaseAttachment = createAction(
    EmployeeCaseActionTypes.RemoveEmployeeCaseAttachment,
    props<{ caseId: string; documentDescriptionId: string }>()
);
export const RemoveEmployeeCaseAttachmentSuccess = createAction(
    EmployeeCaseActionTypes.RemoveEmployeeCaseAttachmentSuccess,
    props<{ caseId: string }>()
);
export const RemoveEmployeeCaseAttachmentFailure = createAction(
    EmployeeCaseActionTypes.RemoveEmployeeCaseAttachmentFailure,
    props<{ error: any }>()
);

export const RejectRequestsByCase = createAction(
    EmployeeCaseActionTypes.RejectRequestsByCase,
    props<{ employeeId: string; caseId: string; requestIds: string[]; reason: string }>()
);
